export default __webpack_public_path__ + "static/media/B85.75967f4a.png";